module.exports = __webpack_public_path__ + "media/images/default_hotel_room_icon-c158897702dc2cd54cf15583116c6ec8.png";